import { useMemo, useContext, useRef, useCallback } from 'react';
import { AppContext, TranslationContext } from '../../../App';

import { Steps } from 'intro.js-react';

import Intro_Settings from '../../../assets/PixelArt/10_Settings.png';
import Intro_Model from '../../../assets/PixelArt/11_Model.png';
import Intro_Edit from '../../../assets/PixelArt/12_Edit.png';
import Intro_Delete from '../../../assets/PixelArt/13_Delete.png';
import Intro_Download from '../../../assets/PixelArt/14_Download.png';
import Intro_HiThere from '../../../assets/PixelArt/1_HiThere.png';
import Intro_GIMPRO from '../../../assets/PixelArt/2_GIMPRO.png';
import Intro_GIMSTORE from '../../../assets/PixelArt/3_GIMSTORE.png';
import Intro_PRJ_List from '../../../assets/PixelArt/4_PRJ_List.png';
import Intro_PRJ_Link from '../../../assets/PixelArt/5_PRJ_Link.png';
import Intro_OBJ_List from '../../../assets/PixelArt/6_OBJ_List.png';
import Intro_OBJ_Link from '../../../assets/PixelArt/7_OBJ_Link.png';
import Intro_ThreeDCanvas from '../../../assets/PixelArt/8_3DCanvas.png';
import Intro_GIMmanager from '../../../assets/PixelArt/9_GIMmanager.png';
import Intro_MyPrj_ from '../../../assets/PixelArt/MyPrj.png';
import { useSelector } from 'react-redux';

/**
 * Tutorial steps for using the GIM website
 * @returns
 */
const GimIntroSteps = ({ isGimConnected, isAuthenticated }) => {
  const { t } = useContext(TranslationContext);
  const { appContext, setAppContext } = useContext(AppContext);
  const StepsRef = useRef(null);

  // checking if mobile view
  const { isMobileView } = useSelector(
    (/** @type {any} */ state) => state?.user
  );

  const allSteps = useMemo(
    () => [
      {
        title: t('Intro.tourGuide'),
        intro: `<div style="display: flex;">
        <div style="display: flex; justify-content: center; width: 70%; align-items: center; padding-right: 8px;">
        ${t('Intro.tourGuideIntro')}
        </div>
        <div style="width: 30%; display: flex; justify-content: center;">
        <img src=${Intro_HiThere} />
        </div>
        </div>`,
        highlightClass: 'appTour',
      },
      {
        title: 'GIMpro',
        element: '#GimPro',
        intro: `<div style="display: flex;">
        <div style="display: flex; justify-content: center; width: 70%; align-items: center; padding-right: 8px;">
        ${t('Intro.gimProIntro')}
        </div>
        <div style="width: 30%; display: flex; justify-content: center;">
        <img src=${Intro_GIMPRO}  />
        </div>
        </div>`,
        highlightClass: 'appTour',
      },
      {
        title: 'GIMstore',
        element: '#GimStore',
        intro: `<div style="display: flex;">
        <div style="display: flex; justify-content: center; width: 70%; align-items: center; padding-right: 8px;">
        ${t('Intro.gimStoreIntro')}
        </div>
        <div style="width: 30%; display: flex; justify-content: center;align-items: center;"">
        <img src=${Intro_GIMSTORE}  />
        </div>
        </div>`,
      },
      {
        title: t('Intro.myProjects'),
        element: '#my-projects',
        intro: `<div style="display: flex;">
        <div style="width: 30%; display: flex; justify-content: center;">
        <img src=${Intro_MyPrj_} />
        </div>
        <div style="display: flex; justify-content: center; width: 70%; align-items: center; padding-left: 8px;">
        ${t('Intro.myProjectsIntro')}
        </div>
        </div>`,
        highlightClass: 'appTour',
      },
      {
        title: t('Intro.projectList'),
        element: '#ProjectList',
        intro: `<div style="display: flex;">
        <div style="display: flex; justify-content: center; width: 70%; align-items: center; padding-right: 8px;">
        ${t('Intro.projectListIntro')}
        </div>
        <div style="width: 30%; display: flex; justify-content: center;align-items: center;"">
        <img src=${Intro_PRJ_List} />
        </div>
        </div>`,
        position: 'right',
        // highlightClass: 'myHighlightClass',
      },
      // {
      //   title: 'Project List',
      //   element: '#ProjectList',
      //   intro: 'Please click on project.',
      //   position: 'right',
      //   hint: 'click on project',
      // },
      {
        title: t('Intro.projectLink'),
        element: '#projectExternalLink',
        // '#ProjectList .d-flex.align-items-center.px-3:nth-child(1) div:nth-child(2)',
        intro: `<div style="display: flex;">
        <div style="display: flex; justify-content: center; width: 70%; align-items: center; padding-right: 8px;">
        ${t('Intro.projectLinkIntro')}
        </div>
        <div style="width: 30%; display: flex; justify-content: center;align-items: center;"">
        <img src=${Intro_PRJ_Link}  />
        </div>
        </div>`,
        position: 'right',
      },
      {
        title: t('Intro.objectList'),
        element: '.tree-view-container',
        intro: `<div style="display: flex;">
        <div style="width: 30%; display: flex; justify-content: center;align-items: center;"">
        <img src=${Intro_OBJ_List}  />
        </div>
        <div style="display: flex; justify-content: center; width: 70%; align-items: center; padding-left: 8px;">
        ${t('Intro.objectListIntro')}
        </div>
        </div>`,
        position: 'right',
      },
      {
        title: t('Intro.objectLink'),
        element:
          '.tree-view-container .tree-view-children div:nth-child(1)  div:nth-child(3)',
        intro: `<div style="display: flex;">
        <div style="width: 30%; display: flex; justify-content: center;align-items: center;"">
        <img src=${Intro_OBJ_Link}  />
        </div>
        <div style="display: flex; justify-content: center; width: 70%; align-items: center; padding-left: 8px;">
        ${t('Intro.objectLinkIntro')}
        </div>
        </div>`,
        position: 'right',
      },
      {
        title: t('Intro.canvas'),
        element: '.viewer-container',
        intro: `<div style="display: flex;">
        <div style="display: flex; justify-content: center; width: 70%; align-items: center; padding-right: 8px;">
        ${t('Intro.canvasIntro')}
        </div>
        <div style="width: 30%; display: flex; justify-content: center;align-items: center;"">
        <img src=${Intro_ThreeDCanvas}  />
        </div>
        </div>`,
        tooltipClass: 'customTooltip',
        position: 'left',
      },
      {
        title: 'GIMmanager',
        element: '#InstallGIMmanager',
        intro: `<div style="display: flex;">
        <div style="display: flex; justify-content: center; width: 70%; align-items: center; padding-left: 8px;">
        ${t('Intro.gimManagerIntro')}
        </div>
        <div style="width: 30%; display: flex; justify-content: center;align-items: center;"">
        <img src=${Intro_GIMmanager}  />
        </div>
        </div>`,
        // position: 'left',
      },
      {
        title: t('Global.settings'),
        element: '#Settings',
        intro: `<div style="display: flex;">
        <div style="width: 30%; display: flex; justify-content: center;align-items: center;"">
        <img src=${Intro_Settings}  />
        </div>
        <div style="display: flex; justify-content: center; width: 70%; align-items: center; padding-left: 8px;">
        ${t('Intro.settingsIntro')}
        </div>
        </div>`,
      },
      {
        title: t('Global.model'),
        element: '#Model',
        intro: `<div style="display: flex;">
        <div style="width: 30%; display: flex; justify-content: center;align-items: center;"">
        <img src=${Intro_Model}  />
        </div>
        <div style="display: flex; justify-content: center; width: 70%; align-items: center; padding-left: 8px;">
        ${t('Intro.modelIntro')}
        </div>
        </div>`,
      },
      {
        title: t('Global.edit'),
        element: '#Edit',
        intro: `<div style="display: flex;">
        <div style="width: 30%; display: flex; justify-content: center;align-items: center;"">
        <img src=${Intro_Edit}  />
        </div>
        <div style="display: flex; justify-content: center; width: 70%; align-items: center; padding-left: 8px;">
        ${t('Intro.editIntro')}
        </div>
        </div>`,
      },
      {
        title: t('Global.delete'),
        element: '#Delete',
        intro: `<div style="display: flex;">
        <div style="width: 30%; display: flex; justify-content: center;align-items: center;"">
        <img src=${Intro_Delete}  />
        </div>
        <div style="display: flex; justify-content: center; width: 70%; align-items: center; padding-left: 8px;">
        ${t('Intro.dowloadIntro')}
        </div>
        </div>`,
      },
      {
        title: `${t('Global.download')}/${t('Global.save')}`,
        element: '#Download',
        intro: `<div style="display: flex;">
        <div style="width: 30%; display: flex; justify-content: center;align-items: center;"">
        <img src=${Intro_Download}  />
        </div>
        <div style="display: flex; justify-content: center; width: 70%; align-items: center; padding-left: 8px;">
        ${t('Intro.dowloadIntro')}
        </div>
        </div>`,
      },
    ],
    [t]
  );

  /**
   * Modified tutorial (skip gimmanager step if it's installed, and my projects if user not logged in)
   */
  const steps = useMemo(() => {
    const newSteps = [...allSteps];
    //
    if (isGimConnected) {
      const GIMstepIndex = newSteps?.findIndex(
        (step) => step.title === 'GIMmanager'
      );
      newSteps.splice(GIMstepIndex, 1);
    }

    if (!isAuthenticated) {
      const myProjectIndex = newSteps.findIndex(
        (step) => step?.title === t('Intro.myProjects')
      );
      newSteps.splice(myProjectIndex, 1);
    }

    return newSteps;
  }, [t, allSteps, isGimConnected, isAuthenticated]);

  /**
   * Runs on exiting the intro
   */
  const onExit = useCallback(() => {
    setAppContext({
      ...appContext,
      showIntro: false,
    });
  }, [appContext, setAppContext]);

  /**
   *
   */
  const onBeforeChange = useCallback(
    async (next, nextElement) => {
      const elemId = nextElement?.getAttribute('id');

      if (next === 0) {
        if (isMobileView) {
          setTimeout(async () => {
            await document
              .querySelector('.toggle.navbar-toggler.collapsed')
              //@ts-ignore
              .click();
          }, 100);
        }

        if (document.querySelector('#basic-nav-dropdown') !== null) {
          //@ts-ignore
          await document.querySelector('#basic-nav-dropdown').click();
          //@ts-ignore
          await document.querySelector('#basic-nav-dropdown').click();
          await StepsRef?.current?.updateStepElement(next);
          // return true
        }
        await StepsRef?.current?.updateStepElement(3);
        return;
      }
      switch (elemId) {
        case 'GimStore':
          // Click on gimstore to show the project list
          if (document.querySelector('#GimStore') !== null) {
            //@ts-ignore
            await document.querySelector('#GimStore').click();
          }

          return;

        case 'my-projects':
          if (document.querySelector('#basic-nav-dropdown') !== null) {
            //@ts-ignore
            await document.querySelector('#basic-nav-dropdown').click();
            await StepsRef?.current?.updateStepElement(next);
            return;
          }

          return;

        case 'ProjectList':
          await StepsRef?.current?.updateStepElement(next);
          // If project not clicked by user then click on first project to get object list
          if (document.querySelector('.tree-view-container') === null) {
            if (
              document.querySelector('#ProjectList .project-title') !== null
            ) {
              await document
                .querySelector('#ProjectList .project-title')
                //@ts-ignore
                .click();
              await StepsRef?.current?.updateStepElement(next + 1);
            }
          }
          await StepsRef?.current?.updateStepElement(next + 1);
          return;
        case 'projectExternalLink':
          await StepsRef?.current?.updateStepElement(next);
          return;
        default:
      }
      switch (next) {
        case 6:
          await StepsRef?.current?.updateStepElement(6);
          await StepsRef?.current?.updateStepElement(next + 1);
          await StepsRef?.current?.updateStepElement(9);
          await StepsRef?.current?.updateStepElement(10);
          await StepsRef?.current?.updateStepElement(11);
          await StepsRef?.current?.updateStepElement(12);
          if (steps?.length > 13) {
            await StepsRef?.current?.updateStepElement(13);
          }
          if (steps?.length > 14) {
            await StepsRef?.current?.updateStepElement(14);
          }
          return;
        case 7:
          await StepsRef?.current?.updateStepElement(7);
          return;
        case 8:
          await StepsRef?.current?.updateStepElement(8);
          if (document.querySelector('#InstallGIMmanager') !== null) {
            StepsRef?.current?.updateStepElement(9);
          }
          return;

        default:
      }
    },
    [isMobileView, steps]
  );

  return (
    <>
      <Steps
        //enabled={appContext.showIntro}
        steps={steps}
        initialStep={0}
        ref={StepsRef}
        onExit={onExit}
        onBeforeChange={onBeforeChange}
        options={{
          hideNext: false,
          hidePrev: true,
          exitOnEsc: true,
          prevLabel: t('Global.back'),
          nextLabel: t('Global.next'),
          doneLabel: t('Global.done'),
          scrollToElement: true,
          scrollPadding: 10,
          showButtons: true,
        }}
      />
    </>
  );
};

export default GimIntroSteps;
